import {
  AppointmentRemoteDataSource,
  AuthRemoteDataSource,
  ChatRemoteDataSource,
  CouponRemoteDataSource,
  FinancialRemoteDataSource,
  NotificationRemoteDataSource,
  PatientRemoteDataSource,
  PaymentRemoteDataSource,
  RatingRemoteDataSource,
  ScheduleRemoteDataSource,
  SettingsRemoteDataSource,
  SharedAppointmentSlotRemoteDataSource,
  SubsRemoteDataSource,
  UserRemoteDataSource,
} from "@phurshell/psiapp-frontend-core/data";
import { api } from "./api";

export const authDataSource = new AuthRemoteDataSource(api);
export const userDataSource = new UserRemoteDataSource(api);
export const appointmentDataSource = new AppointmentRemoteDataSource(api);
export const financialDataSource = new FinancialRemoteDataSource(api);
export const chatDataSource = new ChatRemoteDataSource(api);
export const subsDataSource = new SubsRemoteDataSource(api);
export const paymentDataSource = new PaymentRemoteDataSource(api);
export const settingsDataSource = new SettingsRemoteDataSource(api);
export const scheduleDataSource = new ScheduleRemoteDataSource(api);
export const notificationDataSource = new NotificationRemoteDataSource(api);
export const patientDataSource = new PatientRemoteDataSource(api);
export const ratingDataSource = new RatingRemoteDataSource(api);
export const couponDataSource = new CouponRemoteDataSource(api);
export const sharedAppointmentSlotDataSource =
  new SharedAppointmentSlotRemoteDataSource(api);
